export enum ColumnType {
    None,
    EditableDropdown,
    EditableNumber,
    EditableDate,
    EditableText,
    HyperlinkText,
    EditableNumberValidation,
    Loader,
    HyperlinkTextWithLogo,
    TextWithLogo,
    Image,
    DropdownWithText,
    SimpleDropdown,
    Search,
    Star,
    Checkbox,
    RadioButton,
    EditableTextDisabled,
    HyperlinkWithIcon,
    PackageIdLink,
    SourcingProject,
    Reasons,
    DecidedDropdown,
    MenuItems,
    CopyButton,
    SearchableDropdown,
    ViewButton
}